import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./App.css";
import RouterComponent from "./Components/Routes/RouterComponent";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  function getRandomThreeDigitNumber() {
    return Math.floor(Math.random() * 900) + 100;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <RouterComponent getRandomThreeDigitNumber={getRandomThreeDigitNumber} />{" "}
        {/* useNavigate is used in this component */}
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;